import React from 'react'
import { SelectChangeEvent } from '@mui/material'

import { Select } from '@/components'
import { useB2CState } from '@/stores/slices/b2c-slice'
import { useAppDispatch } from '@/stores/hooks.ts'
import { b2cActions } from '@/stores/slices/b2c-slice/b2c-slice.ts'

const MENU_ITEMS = [
  { value: 'ALL', label: 'Все' },
  { value: 'NEW', label: 'Запрос к получателю' },
  { value: 'PROCESSING', label: 'В работе' },
  { value: 'PAID', label: 'Успешно' },
  { value: 'REJECTED', label: 'Неуспешно' },
]

export const B2CStateFilter = (): React.ReactElement => {
  const { b2cState: state } = useB2CState()
  const dispatch = useAppDispatch()

  const handleStatusChange = (event: SelectChangeEvent) => {
    dispatch(
      b2cActions.setFilter({
        filterKey: 'b2cState',
        filterValue: event.target.value === 'ALL' ? '' : event.target.value,
      })
    )
  }

  const selectValue = state || 'ALL'

  return (
    <Select value={selectValue} onChange={handleStatusChange} items={MENU_ITEMS} label="Статус" labelId="sbp-status" />
  )
}
